const dateAlignModes = {
  Left: 'Left',
  Right: 'Right',
  Center: 'Center',
};

export default dateAlignModes;
